import React from "react";

export default function TermsOfService() {
  return (
    <div className="text-sm text-gray-600 space-y-2">
      <ul className="list-disc pl-5 space-y-1">
        <li>RideFlow is only a platform connecting vehicle owners and renters.</li>
        <li>We do not own, manage, inspect, or insure any listed vehicles.</li>
        <li>Vehicle owners are responsible for vehicle condition, legality, and insurance.</li>
        <li>Renters must follow traffic laws and use vehicles responsibly.</li>
        <li>RideFlow is not responsible for accidents, damage, theft, or misuse.</li>
        <li>Any disputes must be resolved between the owner and the renter.</li>
        <li>Users must provide accurate and truthful information.</li>
        <li>Accounts may be suspended if platform rules are violated.</li>
      </ul>
    </div>
  );
}
